import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReelsSearchPreview } from "../../redux/reels/reelsAction";
import { useNavigate } from "react-router-dom";
import { SyncLoader } from "react-spinners";
import defaultImage from '../../assests/defaultImage.png'
import {
  FaBookmark,
  // FaArrowLeft,
  // FaArrowRight,
  FaTimes
} from "react-icons/fa"; // Import arrow and close icons
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from "react-icons/md";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { AiFillHeart } from "react-icons/ai";
import comment from "../../../src/assests/comment.png"


const VideoPlayer = ({ src, disable, activeIndex, setActiveIndex, adsLenght }) => {
  const playerRef = useRef(null)
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { videoUrl, caption, commentsCount, likesCount, saveCount, user } = src ?? {}
  const { firstName, lastName, profilePhoto, UserName } = user ?? {}
  const profileImage = profilePhoto && profilePhoto?.length > 0 ? profilePhoto[0]?.photoPublicUrl : null



  const handleLoadedData = () => {
    setIsLoading(false);
  };

  const handleClick = () => {
    navigate("/flips");
  };

  const handleProgress = () => {
    const playedSeconds = playerRef.current?.currentTime;
    if (playedSeconds >= 5) {
      playerRef.current?.pause();
      if (adsLenght > 1) handleNext();
    }
  };

  const handleNext = (e) => {
    e?.stopPropagation()
    if (activeIndex === adsLenght - 1) {
      return setActiveIndex(0)
    } else if (activeIndex === 2) {
      return setActiveIndex(0)
    }
    setActiveIndex(activeIndex + 1)
  }

  const handlePrev = (e) => {
    e?.stopPropagation()
    if (activeIndex === 0) {
      if (adsLenght - 1 >= 3) {
        return setActiveIndex(3)
      } else {
        return setActiveIndex(adsLenght - 1)
      }
    }
    setActiveIndex(activeIndex - 1)
  }

  return (
    <div className="relative flex flex-col font-outfit w-full h-full bg-black" >
      {!isLoading && <button className="close-icon absolute top-0 mt-2 mr-2 z-20 right-0 p-2 cursor-pointer rounded-full" onClick={disable}>
        <FaTimes />
      </button>}
      {isLoading && (
        <div className="flex flex-1 flex-col items-center loading-spinner justify-center align-middle">
          <SyncLoader color={"#BE9524"} loading={isLoading} size={10} />
        </div>
      )}
      <div className={`w-full h-full ${isLoading ? "hidden" : "flex flex-col"}`}>
        <video
          ref={playerRef}
          src={videoUrl}
          width={"100%"}
          height="100%"
          muted
          playsInline
          preload="metadata"
          onLoadedData={handleLoadedData}
          onTimeUpdate={handleProgress}
          autoPlay
          className="h-full w-full object-cover"
        />
      </div>


      {/* Overlay components */}
      {!isLoading && (
        <div onClick={handleClick} className="absolute inset-0 bg-black/50 w-full h-full flex flex-col justify-end p-2">

          {adsLenght > 1 && <button onClick={handlePrev} className="text-xl font-bold absolute left-2 top-[45%] p-2 cursor-pointer">
            <MdOutlineArrowBackIosNew />
          </button>}

          {adsLenght > 1 && <button onClick={handleNext} className="text-xl font-bold absolute right-2 top-[45%] p-2 cursor-pointer" >
            <MdOutlineArrowForwardIos />
          </button>}

          <div className="flex flex-row justify-between items-end pb-2">
            <div className="text-sm flex flex-col flex-1">
              <p className="line-clamp-1">
                {caption}
              </p>
              {<p className="line-clamp-1 font-bold" >{UserName ? `BD_@${UserName}` : `${firstName} ${lastName}`} </p>}
            </div>

            <div className="flex flex-col gap-2">
              <img src={profileImage ? profileImage : defaultImage} alt="music" className="w-12 rounded-full" />
              <div className="flex flex-col gap-1 items-center text-[10px]">
                <AiFillHeart  alt="loveIcon" className="w-4 h-4" />
                <text>{likesCount}</text>
              </div>
              <div className="flex flex-col gap-1 items-center text-[10px]">
               <FaBookmark alt="savereals" className="w-4 h-5" />
                <text>{saveCount}</text>
              </div>
              <div className="flex flex-col gap-1 items-center text-center text-[10px]">
                <img src={comment} alt="comment" className="w-4 h-4 cursor-pointer" />
                <text>{commentsCount}</text>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const RealsAdvert = ({ disable }) => {
  const dispatch = useDispatch()
  const { reelsPreviewLoading, reelsSearchPreview } = useSelector((state) => state.reels)
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);

  useEffect(() => {
    const fetchReelsPreview = async () => {
      try {
        await dispatch(getReelsSearchPreview()).unwrap()
      }
      catch (error) {
        toast.error("Failed to get reels try again later")
        disable()
      }
    }

    if (reelsSearchPreview?.length === 0) {
      fetchReelsPreview()
    }
  }, [dispatch, reelsSearchPreview?.length, disable])

  return (
    <motion.div
      initial={{opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="flex rounded-3xl overflow-hidden  justify-center items-center bg-customGray shadow shadow-black/80 w-full h-[min(500px,70vh)]"
    >
      {reelsPreviewLoading && reelsSearchPreview?.length === 0 &&
        <div className=" flex flex-col flex-1 justify-center items-center">
          <div className="loader " />
          Loading...
        </div>
      }
      {reelsSearchPreview?.length > 0 &&
        <VideoPlayer
          src={reelsSearchPreview[activeVideoIndex]}
          disable={disable}
          activeIndex={activeVideoIndex}
          setActiveIndex={setActiveVideoIndex}
          adsLenght={reelsSearchPreview?.length || 1}
        />
      }
      {reelsSearchPreview?.length === 0 && !reelsPreviewLoading &&
        <div className="flex flex-col justify-center items-center space-y-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-customGold animate-bounce"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 13h6m2 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p className="text-xl font-bold animate-fade-in">No reel available now</p>
        </div>
      }
    </motion.div>
  );
};

export default RealsAdvert;
